module.exports = "<things-form title=\"{{ config.form.addText }}\" key=\"thingsAdd.open\" [onSubmit]=\"submit.bind(this)\" [config]=\"config\"></things-form>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/dclean-web-latest/cot-web/src/app/components/things/add/add.component.html
// module id = ../../../../../src/app/components/things/add/add.component.html
// module chunks = main